import { withViewComponent } from '@updater-legacy/components/custom-element';
import '@updater-components/fa-icon';
import styles from './index.css';

export default class Pill extends withViewComponent(styles)() {
  static observedAttributes = ['text', 'name', 'type'];
  static reflectedAttributes = ['text', 'name', 'type'];

  constructor() {
    super();
    this._pill = this.shadowRoot.querySelector('#pill-text');
    this._icon = this.shadowRoot.querySelector('upd-fa-icon');
  }

  updated({ text, name, type }) {
    this.render`
      <div id="pill">
        ${
          name
            ? this.wire(name + type)`<upd-fa-icon name=${name} type=${
                type || 'light'
              }></upd-fa-icon>`
            : ''
        }
        <span id="pill-text">
          ${text ? text : ''}
        </span>
      </div>
    `;
  }
}

customElements.define('upd-pill', Pill);
